import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { BottomNav } from '@/components/app/bottom-nav'
import { Sidebar } from '@/components/app/sidebar'

export const Layout: FC<LayoutProps> = ({ children, hideNav = false }): ReactNode => {
    return (
        <div className='min-h-dvh bg-background'>
            <a
                href='#main'
                className='sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[80] focus:rounded-lg focus:bg-card focus:px-4 focus:py-2.5 focus:text-sm focus:font-semibold focus:shadow-float'
            >
                Skip to content
            </a>

            {!hideNav && <Sidebar />}

            <div className={hideNav ? undefined : 'lg:pl-64 print:pl-0'}>
                <main
                    id='main'
                    className={hideNav ? 'min-h-dvh' : 'min-h-dvh pb-[calc(5.5rem+env(safe-area-inset-bottom))] lg:pb-10 print:pb-0'}
                >
                    {children}
                </main>
            </div>

            {!hideNav && <BottomNav />}
        </div>
    )
}
